import {gql} from '@apollo/client';

export default gql`
  mutation updateConversionUrl($input: UpdateConversionURLInput!) {
    authed {
      success
    }
    updateConversionUrl(input: $input) {
      conversionUrl {
        id
        url
        value
        action
        type
        category
      }
    }
  }
`;
